import { createI18n } from 'vue-i18n'
import { messages } from './messages'
import { normalizeLocale } from './locales'
import { readLocalPreference } from '@/utils/local-preference'

const savedLocale = readLocalPreference('maple-log:locale')
const locale = normalizeLocale(savedLocale)

export const i18n = createI18n({
  legacy: false,
  locale,
  fallbackLocale: 'zh-CN',
  messages,
})
